<template>
  <div>
    <div>
      <NavigationBreadcrumb :items="breadcrumb_items"></NavigationBreadcrumb>
      <h3 class="mt-3">
        {{ $getVisibleNames("mesh.formationarea", true, "Áreas De Formación") }}
        <AlternativeNameButton
          :table_name="'mesh.formationarea'"
          :allows_crud="allows_crud"
        ></AlternativeNameButton>
      </h3>
      <div style="display: flex">
        <div class="col" style="text-align: left">
          <ButtonMedium
            v-can="'mesh.add_formationarea'"
            v-if="allows_crud"
            :tooltip_text="
              $t('reusable.common.addTooltip', {
                entity: $getVisibleNames(
                  'mesh.formationarea',
                  false,
                  'Área De Formación'
                ),
              })
            "
            :text_button="$t('reusable.common.add')"
            :click_button="() => $bvModal.show(`new-formation-area-modal`)"
            :icon="'plus'"
            :variant="'primary'"
          >
          </ButtonMedium>
          <!-- Área de Formación -->
        </div>
      </div>
      <GenericBTable
        v-if="searchFormationArea.length > 0"
        class="formation-area-table"
        :items="formation_areas"
        :pagination="formation_areas.length"
        :fields="FormationAreasFields"
        :filter="input_search"
        :show_pagination="true"
        :search_filter="true"
        :columns_display="true"
        :allows_crud="allows_crud"
        :display_id="display_id"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
      >
        <template v-if="allows_crud" #cell(actions)="row">
          <ButtonSmall
            :tooltip_text="
              $t('reusable.common.editTooltip', {
                entity: $getVisibleNames(
                  'mesh.formationarea',
                  false,
                  'Área De Formación'
                ),
              })
            "
            :click_button="
              () => $bvModal.show(`edit-formation-area-modal-${row.item.id}`)
            "
            :class="``"
            :icon="'square'"
          ></ButtonSmall>
          <ButtonSmall
            :click_button="() => askForDeleteFormationArea(row.item.id)"
            :tooltip_text="
              $t('reusable.common.deleteTooltip', {
                entity: $getVisibleNames(
                  'mesh.formationarea',
                  false,
                  'Área De Formación'
                ),
              })
            "
            :icon="'trash'"
          ></ButtonSmall>
          <b-modal
            :id="`edit-formation-area-modal-${row.item.id}`"
            :title="
              $t('reusable.common.editModalTitle', {
                entity: $getVisibleNames(
                  'mesh.formationarea',
                  false,
                  'Área De Formación'
                ),
              })
            "
            size="lg"
            hide-footer
          >
            <FormationAreaForm
              :FormationArea="row.item"
              @updated="slotUpdatedFormationArea"
              :institution_id="row.item.school"
              :show_title="false"
            ></FormationAreaForm>
          </b-modal>
        </template>
        <template #cell(description)="row">
          <RenderVHtml :content="row.item.description"></RenderVHtml>
        </template>
      </GenericBTable>
      <div v-else>
        <br />
        <!-- áreas de formación -->
        <strong
          >No se han encontrado
          {{
            $getVisibleNames(
              "mesh.formationarea",
              true,
              "Áreas De Formación"
            ).toLowerCase()
          }}.</strong
        >
      </div>
    </div>
    <b-modal
      :id="`new-formation-area-modal`"
      :hide-footer="true"
      :title="
        $t('reusable.common.createModalTitle', {
          entity: $getVisibleNames(
            'mesh.formationarea',
            false,
            'Área De Formación'
          ),
        })
      "
      size="lg"
    >
      <FormationAreaForm
        v-if="user"
        @created="slotCreatedFormationArea"
        :show_title="false"
        :institution_id="user.school"
      ></FormationAreaForm>
    </b-modal>
  </div>
</template>
<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import { toast } from "@/utils/utils";
export default {
  name: "FormationAreaView",
  components: {
    FormationAreaForm: () =>
      import(
        "@/components/mesh/CurricularResources/FormationArea/FormationAreaForm"
      ),
    GenericBTable: () => import("@/components/reusable/GenericBTable"),
    AlternativeNameButton: () =>
      import("@/components/reusable/AlternativeNameButton"),
    ButtonSmall: () =>
      import("@/components/reusable/Buttons/Small/ButtonSmall"),
    ButtonMedium: () =>
      import("@/components/reusable/Buttons/Medium/ButtonMedium"),
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
    NavigationBreadcrumb: () =>
      import("@/components/reusable/NavigationBreadcrumb"),
  },
  props: {
    input_search: {
      type: String,
      default: "",
    },
    display_id: {},
  },
  data() {
    return {
      sortBy: "",
      sortDesc: false,
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      formation_areas: names.FORMATION_AREAS,
    }),
    breadcrumb_items() {
      return [
        { text: this.$t("reusable.breadcrumb.home"), to: "/home" },
        { text: this.$getVisibleNames("mesh.formationarea", true, "Áreas De Formación") },
      ];
    },
    allows_crud() {
      const has_permission = this.$hasPermissions("mesh.add_formationarea");
      if (has_permission) return has_permission;
      else return false;
    },
    formation_areas_fields() {
      return [
        {
          key: "name",
          label: String(
            this.$getVisibleNames(
              "mesh.formationarea",
              true,
              "Áreas De Formación"
            )
          ),
          sortable: true,
          tdClass: "text-left",
          display_column: true,
        },
        {
          key: "description",
          label: this.$t("reusable.common.description"),
          sortable: true,
          tdClass: "text-left",
          display_column: true,
        },
        {
          key: "order",
          label: this.$t("reusable.common.order"),
          sortable: true,
          display_column: true,
        },
        {
          key: "actions",
          label: "",
          display_column: true,
          thClass: "noprint",
          tdClass: "noprint",
        },
      ];
    },
    searchFormationArea: function () {
      return this.formation_areas
        .filter((item) => {
          return (
            item.name.toLowerCase().includes(this.input_search.toLowerCase()) ||
            item.description
              .toLowerCase()
              .includes(this.input_search.toLowerCase())
          );
        })
        .sort(function (a, b) {
          return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
        });
    },
    FormationAreasFields() {
      if (!this.allows_crud)
        return this.formation_areas_fields.filter(
          (field) => !field.requires_allows_crud
        );
      else return this.formation_areas_fields;
    },
  },
  methods: {
    askForDeleteFormationArea(formation_area_id) {
      this.$swal({
        title: this.$t("reusable.common.deleteConfirmTitle", {
          entity: this.$getVisibleNames(
            "mesh.formationarea",
            false,
            "Área De Formación"
          ),
        }),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch(names.DELETE_FORMATION_AREA, formation_area_id)
            .then(() => {
              toast(
                String(
                  this.$getVisibleNames(
                    "mesh.formationarea",
                    false,
                    "Área De Formación"
                  ) +
                    " " +
                    this.$t("reusable.common.deleted")
                )
              );
            });
        }
      });
    },
    slotCreatedFormationArea() {
      this.$bvModal.hide("new-formation-area-modal");
    },
    slotUpdatedFormationArea(formation_area) {
      this.$bvModal.hide(`edit-formation-area-modal-${formation_area.id}`);
    },
  },
  mounted() {
    this.$store.dispatch(names.FETCH_FORMATION_AREAS);
  },
  created() {},
};
</script>

<style scoped>
.td-actions {
  max-width: 100px !important;
}
.title-header {
  padding: 0 1rem;
  margin-top: auto;
}
.search-formation-area {
  max-width: 50rem;
  margin-left: auto;
  margin-right: 18.5%;
  margin-bottom: 1rem;
  margin-top: 0.5rem;
}
.edit-section {
  margin-top: -2%;
}
</style>